"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function abbreviateNumber(num, fixed) {
    if (num === void 0) { num = 0; }
    if (fixed === void 0) { fixed = 0; }
    if (num > 899) {
        return Math.ceil(num / 1000).toFixed(fixed) + 'k';
    }
    else if (num > 89) {
        return (Math.ceil(num / 100) * 100).toFixed(fixed);
    }
    else {
        return num.toFixed(fixed);
    }
}
exports.default = abbreviateNumber;
//# sourceMappingURL=abbreviateNumber.js.map